import { useEffect, useState } from 'react'
import { MenuComponent } from '../../_metronic/assets/ts/components'
import { initialQueryState, KTSVG } from '../../_metronic/helpers'
import { useQueryRequest } from './request'
import { useQueryResponse } from './response'
import { Dateformet } from './UserInfoCell'
import { useSearchParams } from 'react-router-dom';
import { projectCompanyList } from '../master/api'
import { getCompanySession } from './helper'
import { getUserClass } from '../company-module/api'
import clsx from 'clsx'
//import Swal from 'sweetalert2'

/**
 * DatesFilter component for filtering data by date, company, project, category, and other options.
 * - Renders filter UI with date pickers, dropdowns, and checkboxes for various filter options.
 * - Manages filter state, applies filters, and resets data using hooks and context.
 * - Handles validation, error messages, and updates query state and search params.
 */
const DatesFilter = ({ filter_option }) => {
    const { updateState, state } = useQueryRequest()
    const comapnySession = getCompanySession()
    const { isLoading } = useQueryResponse()
    const [form_date, setFromDate] = useState('')
    const [to_date, setToDate] = useState('')
    const [project_id, setProjectId] = useState('');
    const [class_id, setClassId] = useState('');
    const [buying, setBuying] = useState('');
    const [company_id, setCompanyId] = useState('');
    const [company, setCompany] = useState([]);
    // const { order, document } = useMemo(() => state, [state])
    const [order, setOrder] = useState("desc")
    const [errorMessage, setErrorMessage] = useState('')
    const [searchParams, setSearchParams] = useSearchParams();
    // const [noPan, setPanUnverified] = useState(null);
    // const [noBank, setBankUnverified] = useState(null);
    // const [noUpi, setUPIUnverified] = useState(null);

    const [userClasses, setUserClasses] = useState([]); // State to store fetched user classes

    useEffect(() => {
        if (project_id) {
            getUserClass('project_id=' + project_id).then((data) => {
                setUserClasses(data?.data || []); // Assuming `data` is an array of user classes
            });
        }
    }, [project_id]);
    useEffect(() => {
        MenuComponent.reinitialization();
        projectCompanyList().then((d) => setCompany(d.data));

        const proParam = searchParams.get('project_id');
        const comParam = searchParams.get('company_id');
        const fromParam = searchParams.get('form_date');
        const toParam = searchParams.get('to_date');
        const class_id = searchParams.get('class_id');
        const order_sort = searchParams.get('order');

        if (proParam) setProjectId(proParam);
        if (comParam) setCompanyId(comParam);
        if (fromParam) setFromDate(fromParam);
        if (toParam) setToDate(toParam);
        if (class_id) setToDate(class_id);
        if (order_sort) setOrder(order_sort);

    }, []);

    useEffect(() => {
        filterData();
    }, [searchParams]);
    const resetData = () => {
        setOrder('desc')
        setToDate('')
        setFromDate('')
        setProjectId('')
        setCompanyId('')
        setSearchParams('');
        updateState({ filter: undefined, order: 'desc', document: 'all', ...initialQueryState })
    }

    const filterData = () => {
        // Update search params based on user inputs
        const params = { form_date, to_date, project_id, class_id, buying, order };
        if (company_id) params.company_id = company_id;


        setSearchParams(params);
        updateState({
            filter: params,
            order: order,
            ...initialQueryState
        })

    }
    // const setDocument = (type) => {
    //     updateState({
    //         filter: { form_date, to_date, project_id },
    //         order: order,
    //         document: type || 'all',
    //         ...initialQueryState
    //     })

    // }
    const handleFromDateChange = (selectedFromDate) => {
        setErrorMessage('')
        // Check if selectedFromDate is less than toDate before updating state
        if (!to_date || selectedFromDate < to_date) {
            setFromDate(selectedFromDate);
        } else {
            setErrorMessage('From date must be less than To date')
        }
    };

    const getProjectById = (company_id) => {
        // Find the subject with the specified ID
        const projectData = company?.find((item) => Number(item.id) === Number(company_id));
        // If the subject is found, return its sub_subjects, otherwise return an empty array
        return projectData ? projectData.projects : [];
    };

    const handleToDateChange = (selectedToDate) => {
        setErrorMessage('')
        // Check if selectedToDate is greater than fromDate before updating state
        if (!form_date || selectedToDate > form_date) {
            setToDate(selectedToDate);
        } else {
            setErrorMessage('To date must be greater than From date')
        }
    };
    const setOrderBy = (orderby) => {
        // const params = { form_date, to_date, project_id, class_id, buying };
        // if (company_id) params.company_id = company_id;
        // if (orderby) params.orderby = orderby;


        // setSearchParams(params);
        // updateState({
        //     filter: params,
        //     order: orderby,
        //     ...initialQueryState
        // })
        setOrder(orderby)
    }
    const GetProject = ({ company_id, project_id }) => {
        const projectData = getProjectById(company_id)
        const project = projectData?.find((dt) => Number(dt.id) === Number(project_id))
        const companyData = company?.find((item) => Number(item.id) === Number(company_id));
        return <>
            {order &&
                <> <span className='text-success'>{order === 'desc' ? 'Latest' : order === 'unverified' ? 'Unverified' : 'Oldest'} </span><b>/</b></>
            }
            {companyData?.company_name &&
                <><span className='text-dark'>{companyData?.company_name} </span><b>/</b> </>
            }

            {project && <><span className='text-dark'>{project?.project_name} </span>
                <b>/</b></>
            }
        </>
    }
    // const handleCheckboxChange = (setter, currentState) => {
    //     setter(currentState == null ? '1' : null);
    // };
    return (
        <>
            {/* begin::Filter Button */}

            <div className='text-danger fw-semibold fs-5 me-4 pt-5'>
                <GetProject project_id={project_id} order_by={order} company_id={company_id} />
                {form_date && <div>Selected:
                    <span className='text-dark'><b>  <Dateformet data={form_date} /></b> </span>to: <span className='text-dark'><b>
                        {to_date ? <Dateformet data={to_date} /> : '--'}</b></span>
                </div>

                }
            </div>

            <button
                disabled={isLoading}
                type='button'
                className='btn btn-light-primary me-3'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
            >    {state?.filter && '1'}
                <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                Filter
            </button>
            {/* end::Filter Button */}
            {/* begin::SubMenu */}
            <div className='menu menu-sub menu-sub-dropdown w-500px w-md-525px' data-kt-menu='true'>
                {/* begin::Header */}
                <div className='px-7 py-5'>
                    <div className='fs-5 text-dark fw-semibolder'>Filter Options</div>
                </div>
                {/* end::Header */}

                {/* begin::Separator */}
                <div className='separator border-gray-200'></div>
                {/* end::Separator */}

                {/* begin::Content */}
                <div className='px-7 py-5' data-kt-user-table-filter='form'>
                    {/* begin::Input group */}
                    <div class="mb-10">
                        <label class="form-label fw-semibold">Order By:</label>
                        <div class="d-flex flex-column gap-2">
                            {filter_option.includes('kyc_verification') &&
                                <label class="form-check form-check-sm form-check-custom form-check-solid me-5">
                                    <input onChange={(e) => setOrderBy(order === 'unverified' ? 'desc' : 'unverified')} checked={order === 'unverified'} class="form-check-input" type="checkbox" />
                                    <span class="form-check-label">Unverified in top</span>
                                </label>
                            }
                            <label class="form-check form-check-sm form-check-custom form-check-solid me-5">
                                <input onChange={(e) => setOrderBy(order === 'desc' ? 'asc' : 'desc')} checked={order === 'desc'} class="form-check-input" type="checkbox" />
                                <span class="form-check-label">Latest record in top</span>
                            </label>

                        </div>
                    </div>

                    {filter_option.includes('buying') &&
                        <div class="mb-10">
                            <label class="form-label fw-semibold">Select Buying:</label>
                            <div className="row">
                                <div className="col-lg-12 fv-row">
                                    <div className="form-check form-check-inline">
                                        <input
                                            type='radio'
                                            onChange={(e) => setBuying('buying')}
                                            name='buying'
                                            id={'inlineenabled'}
                                            className={clsx(
                                                'form-check-input',
                                            )}
                                            value={'buying'}
                                        />
                                        <label className="form-check-label" for="inlineenabled">
                                            <span className="form-check-label ms-0 fw-semibold fs-6 text-gray-700">Buying</span>
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type='radio'
                                            onChange={(e) => setBuying('not_buying')}
                                            id={'inlinedisabled'}
                                            name='buying'
                                            className={clsx(
                                                'form-check-input',
                                            )}
                                            autoComplete='off'
                                            value={'not_buying'}
                                            checked={buying === 'not_buying'}
                                        />
                                        <label className="form-check-label" for="inlinedisabled">
                                            <span className="form-check-label ms-0 fw-semibold fs-6 text-gray-700">Not Buying</span>
                                        </label>
                                    </div>

                                </div>
                            </div>
                        </div>
                    }



                    {!comapnySession &&
                        <>
                            <div className='row'>
                                <div className='mb-10 col'>
                                    <label className='form-label fs-6 fw-semibold'>Select Company:</label>
                                    <select
                                        className='form-select form-select-solid fw-semibolder'
                                        data-kt-select2='true'
                                        data-placeholder='Select option'
                                        data-allow-clear='true'
                                        data-kt-user-table-filter='project_id'
                                        data-hide-search='true'
                                        onChange={(e) => setCompanyId(e.target.value)}
                                        value={company_id}
                                    >
                                        <option value=''>Select</option>
                                        {company && company?.map((item, index) => (
                                            <option key={index + 1} value={item.id}>
                                                {item?.company_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className='mb-10 col' >
                                    <label className='form-label fs-6 fw-semibold'>Select Project:</label>
                                    <select
                                        className='form-select form-select-solid fw-semibolder'
                                        data-kt-select2='true'
                                        data-placeholder='Select option'
                                        data-allow-clear='true'
                                        data-kt-user-table-filter='project_id'
                                        data-hide-search='true'
                                        onChange={(e) => setProjectId(e.target.value)}
                                        value={project_id}
                                    >
                                        <option value=''>Select</option>
                                        {company_id && getProjectById(company_id)?.map((subSubjectItem, index) => (
                                            <option key={index + 1} value={subSubjectItem.id}>
                                                {subSubjectItem?.project_name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>

                        </>
                    }
                    {filter_option.includes('class') &&
                        <>
                            <div className='mb-10'>
                                <label className='form-label fs-6 fw-semibold'>Select User Category:</label>
                                <select
                                    className='form-select form-select-solid fw-semibolder'
                                    data-kt-select2='true'
                                    data-placeholder='Select option'
                                    data-allow-clear='true'
                                    data-kt-user-table-filter='role'
                                    data-hide-search='true'
                                    onChange={(e) => setClassId(e.target.value)}
                                    value={class_id}
                                >
                                    <option value=''>Select</option>
                                    {userClasses && userClasses?.map((d) => (
                                        <option key={d?.id} value={d?.id}>
                                            {d?.category_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </>
                    }
                    {filter_option.includes('date') &&
                        <>
                            <div className='row'>
                                <div className='mb-10 col'>
                                    <label className='form-label fs-6 fw-semibold'>From Date:</label>
                                    <input
                                        className='form-control form-control-solid fw-semibolder'
                                        type="date"
                                        onChange={(e) => handleFromDateChange(e.target.value)}
                                        value={form_date}
                                    />
                                </div>

                                <div className='mb-5 col'>
                                    <label className='form-label fs-6 fw-semibold'>To Date:</label>
                                    <input
                                        className='form-control form-control-solid fw-semibolder'
                                        type="date"
                                        onChange={(e) => handleToDateChange(e.target.value)}
                                        value={to_date}
                                    />

                                </div>
                            </div>

                            <div className='mb-5'>
                                {errorMessage &&
                                    <div className='text-danger'>{errorMessage}</div>
                                }
                            </div>
                        </>
                    }
                    {/* begin::Actions */}
                    {!comapnySession &&
                        <div className='d-flex justify-content-end'>
                            <button
                                type='button'
                                disabled={isLoading}
                                onClick={resetData}
                                className='btn btn-light btn-active-light-primary fw-semibold me-2 px-6'
                                data-kt-menu-dismiss='true'
                                data-kt-user-table-filter='reset'
                            >
                                Reset
                            </button>
                            <button
                                disabled={errorMessage}
                                type='button'
                                onClick={filterData}
                                className='btn btn-primary fw-semibold px-6'
                                data-kt-menu-dismiss='true'
                                data-kt-user-table-filter='filter'

                            >
                                Apply
                            </button>
                        </div>
                    }
                    {/* end::Actions */}
                </div>
                {/* end::Content */}
            </div >
            {/* end::SubMenu */}
        </>
    )
}

export { DatesFilter }
